export enum SalamatServicesType {
  drug = 1,
  test = 2,
  imaging = 3,
  physiotherapy = 4,
  doctor = 5,
  reference = 6,
  bulk = 7,
  dentist = 8,
}

export enum SalamatDrugShape{
  T="T",
  C="C",
  A="A",
  S="S",
  R="R",
  Z="Z",
  G="G",
  I="I",
  D="D",
  O="O",
}